"use client";
import {
  Fees
} from "./chunk-YYOB63TP.mjs";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Link_default
} from "./chunk-ZRVIWEMV.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/AccordionsPanel/AccordionsPanel.tsx
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AccordionsPanel = forwardRef(
  function AccordionsPanel2({
    accordions_pannel: {
      title,
      referId,
      theme = { backgroundColorType: "display", backgroundColorValue: "50" },
      itens,
      images,
      link,
      buttonLabel
    }
  }) {
    const ariaLabelLinkVerification = (buttonLabel2) => {
      if (buttonLabel2) {
        return `Saiba mais sobre ${buttonLabel2}`;
      }
      return "Clique aqui para mais informa\xE7\xF5es";
    };
    return /* @__PURE__ */ jsx(
      "div",
      {
        id: referId,
        className: `w-full bg-${theme.backgroundColorType}-${theme.backgroundColorValue}`,
        children: /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center py-32 md:py-80 px-24 w-full", children: /* @__PURE__ */ jsxs("div", { className: "flex overflow-hidden flex-col lg:flex-row items-center lg:items-stretch md:max-w-[720px] lg:max-w-[1170px] md:rounded-6xl md:border md:border-display-300", children: [
          /* @__PURE__ */ jsx("div", { className: "hidden lg:flex overflow-hidden relative w-full max-w-[585px]", children: /* @__PURE__ */ jsx(
            Image_default,
            {
              src: images.web.path,
              width: 720,
              height: 878,
              alt: images.web.alternativeText,
              className: "object-cover object-center w-full h-auto"
            }
          ) }),
          /* @__PURE__ */ jsx("div", { className: "hidden md:flex lg:hidden overflow-hidden w-full max-w-[455px] md:max-w-[720px] h-full max-h-[455px] md:max-h-[560px] rounded-2xl md:rounded-b-none", children: /* @__PURE__ */ jsx(
            Image_default,
            {
              src: images.tablet.path || images.web.path,
              width: 720,
              height: 560,
              alt: images.tablet.alternativeText || images.web.alternativeText,
              className: "object-cover"
            }
          ) }),
          /* @__PURE__ */ jsx("div", { className: "flex md:hidden overflow-hidden w-full max-w-[455px] md:max-w-[720px] h-full max-h-[455px] md:max-h-[560px] rounded-2xl md:rounded-b-none", children: /* @__PURE__ */ jsx(
            Image_default,
            {
              src: images.mobile.path || images.web.path,
              width: 455,
              height: 455,
              alt: images.mobile.alternativeText || images.web.alternativeText,
              className: "object-cover"
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { className: "flex-1 p-0 md:p-40 mt-24 md:mt-0 w-full lg:min-w-[500px] max-w-[455px] md:max-w-[720px] lg:max-w-none h-auto md:bg-display-0", children: [
            /* @__PURE__ */ jsx(Fees, { title, itens }),
            /* @__PURE__ */ jsx("div", { className: "flex gap-4 items-center pt-20", children: (link == null ? void 0 : link.path) && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                Link_default,
                {
                  href: link.path,
                  target: "_blank",
                  className: "text-base font-sans font-semibold text-stone-500",
                  rel: "noreferrer",
                  "aria-label": ariaLabelLinkVerification(buttonLabel),
                  children: buttonLabel
                }
              ),
              /* @__PURE__ */ jsx(
                Icon_default,
                {
                  name: "arrowUpRight",
                  className: "h-10 w-10 fill-current text-stone-500"
                }
              )
            ] }) })
          ] })
        ] }) })
      }
    );
  }
);
var AccordionsPanel_default = AccordionsPanel;

export {
  AccordionsPanel_default
};
